import Layout from "../components/site/Layout";
import Hero from "../components/site/Hero";
import SixRisks from "../components/site/SixRisks";
import CaseStudies from "../components/site/CaseStudies";
import NextStep from "../components/site/NextStep";

export default function Landing() {
  return (
    <Layout pageName="home">
      <Hero />
      <SixRisks />
      <CaseStudies />
      <NextStep />
    </Layout>
  );
}
